import PropTypes from "prop-types"

export const UpsellTabPropTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.string,
  disabled: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right"]),
  selected: PropTypes.bool,
  tooltip: PropTypes.string,
}

export const UPSELL_TABS_SHAPE = PropTypes.arrayOf(PropTypes.shape(UpsellTabPropTypes)).isRequired
